export const fr = {
  ctaButtons: {
    request_event: 'Demander à organiser une activité de bénévolat',
    request_event_desc: "Laissez l’équipe de Purposely trouver l’activité de bénévolat idéale pour vous ou votre équipe!",
    create_event: 'Créer un événement bénévole',
    create_event_desc: 'Vous avez déjà prévu une activité? Vous pouvez créer la vôtre!',
  }
}